import { baseUrl } from "../utils";
import { Vector3 } from "three";

export type CommonOptions = {
  RADIUS: 300;
  GLOBE_SEGMENTS: number;
  CAMERA_FAR: number; // RADIUS * 100
  CAMERA_FOV: number;
  CAMERA_NEAR: number;
};

export const commonOption: CommonOptions = {
         RADIUS: 300,                                   // 球大小
         CAMERA_FAR: 300 * 1000, // RADIUS * 100         // 相机位置
         CAMERA_FOV: 45,
         CAMERA_NEAR: 1,
         GLOBE_SEGMENTS: 100,
       };
export type XYZ = {
  x: number;
  y: number;
  z: number;
}
type ModeOption =　{
  globeRotateSpeed: number,
  cameraPosition: XYZ,
  cameraLookAt: XYZ
}

export type ResourcesOptions = {
  globeTexture: string;
  sunLightIntensity: number;
  sunLightAutoRotateSpeed: number;
  tweenDuration: number;
  globeTweenRotateSpeed: number;
  groundModel: string;
  groundCameraLookAt: Vector3;
  groundCameraInitPos: Vector3;
  groundCameraAutoRotateSpeed: number;
  sunLightOrbitPos: number;
  modes: ModeOption[];
  sunLightPosition: Vector3;
};

const marsOptions: ResourcesOptions = {
  // texture: "https://fdb.ubug.io/super-wallpaper/Mars8K.png",         // 50.37MB
  // texture: "https://fdb.ubug.io/super-wallpaper/Mars8K_web.jpg",     // 11.7MB
  // texture: "https://fdb.ubug.io/super-wallpaper/Mars8K_web_low.jpg", // 4.94MB
  globeTexture: `${baseUrl}/Mars8K_web_low.jpg`,
  sunLightIntensity: 2.5,
  tweenDuration: 1200,
  globeTweenRotateSpeed: (Math.PI / 360) * 8,
  sunLightAutoRotateSpeed: Math.PI / 360 / 16,
  groundModel: `${baseUrl}/mars1.glb`,
  groundCameraLookAt: new Vector3(0, 0, 2),
  groundCameraInitPos: new Vector3(0, 0, -0.5),
  groundCameraAutoRotateSpeed: Math.PI / 360 / 24,
  sunLightPosition: new Vector3(
    0,
    commonOption.RADIUS * 3,
    commonOption.RADIUS * 3
  ),
  sunLightOrbitPos: commonOption.RADIUS * 2,
  modes: [
    {
      globeRotateSpeed: Math.PI / 360 / 6,
      cameraPosition: {
        x: commonOption.RADIUS * 6,
        y: 0,
        z: 0,
      },
      cameraLookAt: {
        x: 0,
        y: 0,
        z: 0,
      },
    },
    {
      globeRotateSpeed: Math.PI / 360 / 24,
      cameraPosition: {
        x: commonOption.RADIUS * 2.5,
        y: commonOption.RADIUS / 8,
        z: commonOption.RADIUS / 2,
      },
      cameraLookAt: {
        x: (commonOption.RADIUS * 2.5) / 2,
        y: commonOption.RADIUS / 8,
        z: commonOption.RADIUS / 2,
      },
    },
    {
      globeRotateSpeed: Math.PI / 360 / 36,
      cameraPosition: {
        x: commonOption.RADIUS * 2,
        y: commonOption.RADIUS / 8,
        z: commonOption.RADIUS / 2,
      },
      cameraLookAt: {
        x: 0,
        y: 0,
        z: 0,
      },
    },
  ],
};

export const mars = marsOptions;
